import { SupportedRegions } from "@nova/constants"
import { z } from "zod"
import { processingPayloadSchema } from "./descriptors"

const sqsProcessingEventSchema = z.object({
    source: z.literal("sqs"),
    requestId: z.string(),
    payload: processingPayloadSchema,
    region: z.enum(SupportedRegions),
})

export type SQSProcessingEvent = z.infer<typeof sqsProcessingEventSchema>

const manualProcessingEventSchema = z.object({
    source: z.literal("manual"),
    payload: processingPayloadSchema,
    region: z.enum(SupportedRegions),
})

export const processingEventSchema = z.discriminatedUnion("source", [
    sqsProcessingEventSchema,
    manualProcessingEventSchema,
])

export type ProcessingEvent = z.infer<typeof processingEventSchema>
